import {
  HEARINGSTATUS_ACTIVE,
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGSTATUS_AWAITING_STARTDATE,
  HEARINGSTATUS_CONCLUDED,
} from '../constants/api';
import { Pages } from '../constants/pages';
import { filterAndSortingKeys } from './filterAndSortingsUtil';

export const pageFilterSelections = {
  [Pages.CurrentHearingsPage]: {
    [filterAndSortingKeys.hearingStatus]: [
      HEARINGSTATUS_AWAITING_STARTDATE,
      HEARINGSTATUS_ACTIVE,
    ],
  },
  [Pages.ConcludedHearingsPage]: {
    [filterAndSortingKeys.hearingStatus]: [
      HEARINGSTATUS_AWAITING_CONCLUSION,
      HEARINGSTATUS_CONCLUDED,
    ],
  },
};
